if (!customElements.get('td-slideshow')) {
  customElements.define('td-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.eventHandlers = [];
      const on = (target, event, handler) => { target.addEventListener(event, handler); this.eventHandlers.push([target, event, handler]); };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.controls = this.querySelector('.td-slideshow-controls');
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('[data-total]').textContent = this.slides.length;
      this.controls.hidden = false;
      on(this.querySelector('[data-previous]'), 'click', () => this.step(-1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.step(1, true));
      on(this.toggle, 'pointerdown', () => { this.pointerPaused = this.paused; });
      on(this.toggle, 'pointercancel', () => { this.pointerPaused = undefined; });
      on(this.toggle, 'click', () => { this.paused = !(this.pointerPaused ?? this.paused); this.pointerPaused = undefined; this.updateTimer(); });
      on(this, 'focusin', () => { this.paused = true; this.updateTimer(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.updateTimer(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.updateTimer(); });
      on(this, 'pointerdown', event => {
        this.swipeStart = undefined;
        if (event.pointerType !== 'touch' || event.target.closest('button, a, input, select, textarea')) return;
        this.swipeStart = { x: event.clientX, y: event.clientY };
      });
      on(this, 'pointerup', event => {
        if (!this.swipeStart) return;
        const dx = event.clientX - this.swipeStart.x;
        const dy = event.clientY - this.swipeStart.y;
        this.swipeStart = undefined;
        if (Math.abs(dx) >= 60 && Math.abs(dx) > Math.abs(dy) * 1.3) this.step(dx < 0 ? 1 : -1, true);
      });
      on(this, 'pointercancel', () => { this.swipeStart = undefined; });
      this.visibilityHandler = () => this.updateTimer();
      this.motionHandler = () => { if (this.motion.matches) this.paused = true; this.updateTimer(); };
      on(document, 'visibilitychange', this.visibilityHandler);
      on(this.motion, 'change', this.motionHandler);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.updateTimer(); });
      this.observer.observe(this);
      this.step(0);
    }
    step(delta, manual = false) {
      this.index = (this.index + delta + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === this.index); slide.setAttribute('aria-hidden', String(i !== this.index)); slide.inert = i !== this.index; });
      this.querySelector('[data-current]').textContent = this.index + 1;
      if (manual) { this.paused = true; this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length} — ${this.slides[this.index].getAttribute('aria-label')}`; }
      this.updateTimer();
    }
    updateTimer() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      if (!this.paused && !this.hovered && !document.hidden && this.inView !== false) this.timer = setInterval(() => this.step(1), 6500);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.eventHandlers?.forEach(([target, event, handler]) => target.removeEventListener(event, handler));
      this.eventHandlers = [];
      this.pointerPaused = undefined;
      this.swipeStart = undefined;
      this.initialized = false;
    }
  });
}
